<template>
  <div>
    <b-card>
      <div v-if="loading">
        <b-skeleton width="25%" height="30px"></b-skeleton>
        <b-row justify-center>
          <b-col cols="3" class="p-1" v-for="n in 8" :key="n">
            <div class="border rounded px-2 p-1">
              <b-skeleton></b-skeleton>
              <b-skeleton></b-skeleton>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <div class="d-flex justify-space-between">
          <h2>{{ user.full_name }}</h2>
          <div>
            <!-- <b-button> </b-button> -->
          </div>
        </div>
        <b-row justify-space-between>
          <b-col cols="3" class="p-1">
            <div class="border rounded px-2 p-1">
              <h5 class="mb-1 bold text-primary">الاسم</h5>
              <div>{{ user.full_name }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="border rounded px-2 p-1">
              <h5 class="mb-1 bold text-primary">اسم المستخدم</h5>
              <div>{{ user.username }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="border rounded px-2 p-1">
              <h5 class="mb-1 bold text-primary">البريد الإلكتروني</h5>
              <div>{{ user.email }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="border rounded px-2 p-1">
              <h5 class="mb-1 bold text-primary">رقم الموبايل</h5>
              <div class="number-display">{{ user.mobile }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="border rounded px-2 p-1">
              <h5 class="mb-1 bold text-primary">رقم الهاتف</h5>
              <div class="number-display">{{ user.phone }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="border rounded px-2 p-1">
              <h5 class="mb-1 bold text-primary">المحافظة</h5>
              <div>{{ user.governorate ? user.governorate.name_ar : "" }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="p-1">
            <div class="border rounded px-2 p-1">
              <h5 class="mb-1 bold text-primary">تاريخ الميلاد</h5>
              <div>{{ $moment(user.dob).format("DD-MM-YYYY") }}</div>
            </div>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end w-100">
          <b-button v-can="{ slug: $route.meta.slug, action: 'O' }" class="mx-2" variant="primary"
            @click="onAddClickedPassword(user)"><feather-icon icon="KeyIcon" class="mr-50" />تعديل كلمة السر
          </b-button>

          <b-button v-can="{ slug: $route.meta.slug, action: 'U' }" variant="success"
            @click="onUpdateClicked(user)"><feather-icon icon="PlusIcon" class="mr-50" />تعديل
          </b-button>
        </div>
      </div>
    </b-card>
    <form-modal ref="estateModalUser" :formSchema="estatesFormSchema" title="تعديل الملف الشخصي" v-model="updateModel"
      :loading="updateLoading" @confirm="onModalConfirmed">
    </form-modal>
    <form-modal ref="passwordModalUserProfile" :formSchema="passwordFormSchema" title="تغيير كلمة السر" :loading="loading"
      v-model="passwordactivModel" @confirm="onModalConfirmedPassword">
    </form-modal>
  </div>
</template>
<script>
import FormModal from "@/components/FormModal.vue";
import authHelpers from "@/utils/auth-helpers";
import { BCard, BRow, BCol, BButton, BSkeleton } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { formatDateToHuman } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    FormModal,
    BSkeleton,
  },

  data() {
    return {
      updateModel: false,
      passwordactivModel: false,
      oldForm: {},
      estatesFormSchema: {
        full_name: {
          component: "FormInput",
          key: "full_name",
          attrs: {
            label: "الاسم الكامل",
            rules: "required",
          },
        },
        sername: {
          component: "UsernameInput",
          key: "username",
          attrs: {
            label: "اسم المستخدم",
            rules: "required",
            isMinistry: authHelpers.isUserMinistry(),
          },
        },
        email: {
          component: "EmailInput",
          key: "email",
          attrs: {
            label: "البريد الإلكتروني*",
            rules: "required|email",
            isMinistry: authHelpers.isUserMinistry(),
          },
        },
        mobile: {
          component: "MobileInput",
          key: "mobile",
          attrs: {
            id: "mobile-input",
            label: "رقم الموبايل*",
            rules: "required",
            isMinistry: authHelpers.isUserMinistry(),
          },
        },
        phone: {
          component: "PhoneInput",
          key: "phone",
          attrs: {
            id: "phone-input",
            label: " رقم الهاتف",

            isMinistry: authHelpers.isUserMinistry(),
          },
        },
        dob: {
          component: "FormMask",
          key: "dob",
          attrs: {
            label: "تاريخ الميلاد",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },
        // governorate_id: {
        //   component: "FormSelect",
        //   key: "governorate_id",
        //   attrs: {
        //     reduce: (x) => x.id,
        //     getOptionLabel: (x) => x.name_ar,
        //     id: "users_gov_manage_",
        //     label: "المحافظة",
        //     ep: "v2/guest/selects/governorates",
        //     rules: "required",
        //   },
        // },
      },
      passwordFormSchema: {
        old_password: {
          component: "FormPassword",
          key: "old_password",
          attrs: {
            id: "old_password",
            label: " كلمة السر الخاصة بك",
            rules: "required|min:8",
          },
        },
        new_password: {
          component: "FormPassword",
          key: "new_password",
          attrs: {
            id: "new_password",
            label: " كلمة السر الجديدة ",
            rules: "required|min:8",
          },
        },
        new_password_confirmation: {
          component: "FormPassword",
          key: "new_password_confirmation",
          attrs: {
            id: "new_password_confirmation",
            label: "تأكيد كلمة السر ",
            rules: "required|min:8",
          },
        },
      },
    };
  },
  computed: {
    governorateEp() {
      return authHelpers.isUserMinistry()
        ? "v2/ministry/selects/governorates"
        : "v2/selects/governorates";
    },
  },
  methods: {
    ...mapActions("profile/profile", [
      "getUserInfo",
      "updateUser",
      "changePassword",
    ]),
    formatDateToHuman,
    onUpdateClicked(form) {
      var toUpdate = {
        id: form.id,
        full_name: form.full_name,
        username: form.username,
        password: form.password,
        governorate_id: form.governorate.id,
        dob: form.dob,
        mobile: form.mobile,
        phone: form.phone,
        email: form.email,
        is_blocked: form.is_blocked,
        is_locked: form.is_locked,
      };
      this.oldForm = { ...toUpdate }
      this.$refs.estateModalUser.init(toUpdate);
      this.updateModel = true;
    },
    onAddClickedPassword(form) {
      var toUpdate = {
        id: form.id,
        // new_password: "",
        // new_password_confirmation: "",
        // old_password: "",
      };
      this.$refs.passwordModalUserProfile.init(toUpdate);
      this.activModel = false;
      this.passwordactivModel = true;
    },
    onModalConfirmedPassword(form) {
      const toUpdate = {
        new_password: form.new_password,
        new_password_confirmation: form.new_password_confirmation,
        old_password: form.old_password,
      };
      this.changePassword(toUpdate).then(() => {
        this.passwordactivModel = false;
      });
    },

    async onModalConfirmed(form) {

      await this.updateUser(form).then(() => {
        this.updateModel = false;
      });
    },
  },

  computed: {
    ...mapGetters("profile/profile", ["user", "loading", "updateLoading"]),
  },
  created() {
    this.getUserInfo();
  },
};
</script>

<style lang="scss" scoped>
[dir="rtl"] .number-display {
  direction: ltr;
  width: fit-content;
  writing-mode: lr;
}
</style>
